import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import {
  IgCloseButton,
  IgCopyTextTypography,
  IgDivider,
  IgIconButton,
  IgTooltip,
  IgTypography,
} from "@intelligems/ig-theme";
import { capitalizeFirstLetter } from "@intelligems/ig-utils";
import { Drawer, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import { useGetOrg } from "../../../../api/organizations/get-organization";
import { OpenLinkIcon } from "../../../../images/Icons/OpenLinkIcon";
import { getDrawer, setDrawer } from "../../../../store/slices/global";
import theme from "../../../../theme";
import { removeNumberAndHyphen } from "../../Utils/utils";

import { reasonDescriptionMapping } from "./utils";

const classes = {
  title: `OrderExampleDrawer-title`,
};
const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: "350px",
    borderRadius: "0px",
    padding: "20px",
    paddingLeft: "40px",
  },
  [`& .${classes.title}`]: {
    fontSize: "20px",
    fontWeight: 600,
  },
}));

export const OrderExampleDrawer = () => {
  const dispatch = useDispatch();
  const metricDetailsDrawer = useSelector(getDrawer("orderExamples"));
  const drawerProps: { data: any } | undefined = metricDetailsDrawer?.props;
  const organization = useGetOrg();

  const handleDrawerClose = () => {
    dispatch(
      setDrawer({
        drawer: "orderExamples",
        open: false,
        props: undefined,
      })
    );
  };
  if (!drawerProps) {
    return null;
  }

  return (
    <StyledDrawer
      anchor={"right"}
      open={metricDetailsDrawer.isOpen}
      onClose={handleDrawerClose}
    >
      <Grid container direction={"column"} rowSpacing={1}>
        <Grid
          container
          item
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Grid item xs={10}>
            <IgTypography igStyle={"semibold"} sx={{ fontSize: "18px" }}>
              {capitalizeFirstLetter(
                removeNumberAndHyphen(
                  drawerProps.data["EXCLUSION_REASON_DESCRIPTION"]
                )
              )}
            </IgTypography>
          </Grid>
          <Grid item xs={2}>
            <IgCloseButton onClick={handleDrawerClose} />
          </Grid>
        </Grid>
        <Grid item>
          <IgTypography sx={{ fontSize: "15px" }}>
            {
              reasonDescriptionMapping[
                drawerProps.data["EXCLUSION_REASON_DESCRIPTION"]
              ]
            }
          </IgTypography>
        </Grid>
        <Grid item>
          <IgDivider spacing={"s"} />
        </Grid>
        <Grid item>
          <IgTypography igStyle={"semibold"} sx={{ fontSize: "15px" }}>
            Example Order IDs:
          </IgTypography>
        </Grid>
        <Grid item container direction={"column"}>
          {Object.entries(drawerProps.data["ORDER_IDS"])
            .slice(0, 10)
            .map(([key, value], index) => (
              <Grid
                item
                key={index}
                container
                direction={"row"}
                alignItems={"center"}
                columnSpacing={1}
              >
                <Grid item>
                  <IgCopyTextTypography
                    text={value as string}
                    toastMessage={(text) =>
                      toast.success(`Order Name ${text} Copied`)
                    }
                  />
                </Grid>
                <Grid item>
                  <IgCopyTextTypography
                    text={`(${key})`}
                    customCopyText={key}
                    toastMessage={(text) =>
                      toast.success(`Order ID ${key} Copied`)
                    }
                  />
                </Grid>
                {organization?.data?.org?.shopId && (
                  <Grid item xs={1}>
                    <IgTooltip title={"Open order in Shopify"}>
                      <IgIconButton
                        sx={{ color: theme.palette.primary.main }}
                        onClick={() => {
                          window.open(
                            `https://admin.shopify.com/store/${organization.data.org.shopId?.replace(
                              ".myshopify.com",
                              ""
                            )}/orders/${key}`
                          );
                        }}
                      >
                        <OpenLinkIcon
                          fill={theme.palette.primary.light}
                          sx={{
                            width: "12px",
                            height: "12px",
                          }}
                        />
                      </IgIconButton>
                    </IgTooltip>
                  </Grid>
                )}
              </Grid>
            ))}
        </Grid>
      </Grid>
    </StyledDrawer>
  );
};
